export type BrokerNerdsBarkerCoreEnumsPaymentStatus = (typeof BrokerNerdsBarkerCoreEnumsPaymentStatus)[keyof typeof BrokerNerdsBarkerCoreEnumsPaymentStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BrokerNerdsBarkerCoreEnumsPaymentStatus = {
  Unknown: 'Unknown',
  Unpaid: 'Unpaid',
  Paid: 'Paid',
  Partial: 'Partial',
  Void: 'Void',
} as const;
